export default __webpack_public_path__ + "static/media/fish_and_scales.72bfe6be.jpg";